import { JSXElementConstructor } from "react";
import { CircleHelpIcon, ExchangeIcon, HomeIcon, StarIcon, UserIcon, WalletIcon, SignOutIcon } from "ui/common/icons";
import { HelpRoutes } from "ui/common/router/HelpRouter.types";
import { MainRoutes } from "ui/common/router/MainRouter.types";
import { LocaleTranslationResource } from "ui/locale";
import { REDEEM_TABS } from "ui/redeem/containers/RedeemTabs/RedeemTabs";
import { TransactionsRoutes } from "ui/transactions/router/TransactionsRouter";
import { useLogout as useLogOut } from "features/auth/hooks/useLogout";

export interface MainDrawerLink {
    label: LocaleTranslationResource;
    to: string;
    icon: JSXElementConstructor<Record<string, unknown>>;
    onClick?: () => void;
}

export function useMainDrawerLinks(): MainDrawerLink[] {
    const { logOut } = useLogOut();

    return [
        {
            label: "home",
            to: MainRoutes.MAIN,
            icon: HomeIcon,
        },
        {
            label: "programs",
            to: MainRoutes.PROGRAMS,
            icon: StarIcon,
        },
        {
            label: "redeemPoints",
            to: MainRoutes.REDEEM.replace(":type", REDEEM_TABS[0].path),
            icon: WalletIcon,
        },
        {
            label: "activity",
            to: TransactionsRoutes.MAIN,
            icon: ExchangeIcon,
        },
        {
            label: "profile",
            to: MainRoutes.PROFILE,
            icon: UserIcon,
        },
        {
            label: "help",
            to: HelpRoutes.HELP,
            icon: CircleHelpIcon,
        },
        {
            label: "logout",
            to: "",
            icon: SignOutIcon,
            onClick: logOut,
        },
    ];
}
